import React from "react";

const Pagination = ({ currentPage, totalPages, onPageChange, pageSize }) => {
  const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 7; // Maksimum görünen sayfa sayısı

    if (totalPages <= maxVisible) {
      // Tüm sayfaları göster
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      // Karmaşık pagination mantığı
      if (currentPage <= 4) {
        // İlk sayfalar
        for (let i = 1; i <= 5; i++) {
          pages.push(i);
        }
        pages.push("...");
        pages.push(totalPages - 1);
        pages.push(totalPages);
      } else if (currentPage >= totalPages - 3) {
        // Son sayfalar
        pages.push(1);
        pages.push(2);
        pages.push("...");
        for (let i = totalPages - 4; i <= totalPages; i++) {
          pages.push(i);
        }
      } else {
        // Orta sayfalar
        pages.push(1);
        pages.push(2);
        pages.push("...");
        pages.push(currentPage - 1);
        pages.push(currentPage);
        pages.push(currentPage + 1);
        pages.push("...");
        pages.push(totalPages - 1);
        pages.push(totalPages);
      }
    }

    return pages;
  };

  const pageNumbers = getPageNumbers();

  return (
    <div className="flex items-center justify-between py-4 px-6 bg-gray-50" style={{ borderTop: "1px solid #E4E7EC" }}>
      {/* Page Size Info */}
      <div className="text-sm text-gray-600">{pageSize && `Sayfa başına ${pageSize} kayıt gösteriliyor`}</div>

      <nav className="flex items-center space-x-1">
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className="px-3 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          Önceki
        </button>

        {pageNumbers.map((page, index) => (
          <React.Fragment key={index}>
            {page === "..." ? (
              <span className="px-3 py-2 text-sm font-medium text-gray-500">...</span>
            ) : (
              <button
                onClick={() => onPageChange(page)}
                className={`px-3 py-2 text-sm font-medium border rounded-lg transition-colors ${
                  page === currentPage ? "text-white bg-blue-600 border-blue-600 font-bold shadow-md" : "text-gray-700 bg-white border-gray-300 hover:bg-blue-50 hover:border-blue-300"
                }`}
              >
                {page}
              </button>
            )}
          </React.Fragment>
        ))}

        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="px-3 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          Sonraki
        </button>
      </nav>
    </div>
  );
};

export default Pagination;
